import React from 'react';

export const Movie = React.lazy(() => import('./Movie').then((m) => ({ default: m.Movie })));
